import { normalizePushNotificationBody } from './pushNotificationText';
import {
  INCOMING_CALL_REQUEST_TYPE,
} from './pushCallNotificationPolicy';
import {
  normalizePushText,
  readPushTypeKeys,
  resolvePushBody,
  resolvePushTitle,
} from './pushPayloadCore';

export const resolvePushNotificationIcon = (payload, data) => {
  const rawIcon = payload?.notification?.icon;
  if (typeof rawIcon === 'string' && rawIcon.trim()) {
    return rawIcon.trim();
  }

  const { type } = readPushTypeKeys(data);
  if (type === INCOMING_CALL_REQUEST_TYPE) {
    const callType = normalizePushText(data?.callType).toLowerCase();
    if (callType === 'video') return '/icons/push-incoming-call-video.svg';
    return '/icons/push-incoming-call-voice.svg';
  }

  return '/favicon.ico';
};

export const resolvePushNotificationTag = (payload, data, tagPrefix = 'juicyhouse') =>
  data?.notificationId ||
  data?.notification_id ||
  payload?.messageId ||
  `${tagPrefix}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

export const resolveFcmNotificationTitle = (payload, data, defaultTitle) =>
  resolvePushTitle(payload, data) || defaultTitle;

export const resolveFcmNotificationBody = (payload, data) =>
  normalizePushNotificationBody(resolvePushBody(payload, data), data);
